import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory } from "react-router-dom";
import { Row, Col, CardBody, Input, Button, FormGroup, Label } from 'reactstrap';
import Select from 'react-select';
import moment from "moment";
import { toast } from 'react-toastify';
import APIClient from '../../helpers/APIClient';
import PageTitle from '../../components/PageTitle';
import PageBody from '../../components/PageBody';
import Loader from '../../components/Loader';
import ModalPopup from '../../components/ModalPopup';
import PriceUtils from '../../helpers/PriceUtils';
import { connect } from 'react-redux';
import { baseUrl } from '../../constants/environment';
import styled from 'styled-components';
import TextUtils from '../../helpers/TextUtils';
import { checkRole } from '../../helpers/Roles';
import NumberFormat from 'react-number-format';
import ReceiptsAdd from '../receipts/ReceiptsAdd';
import profilePic from '../../assets/images/users/no-img.jpg';
import iconViewMore from '../../assets/images/icon-view-more.png';
import { useReactToPrint } from 'react-to-print';
import PrintContent from './components/PrintContent';


const OrderType = [
    {
        value:'pos',
        label: "POS"
    },
    {
        value:'cms',
        label: "CMS"
    },
]
const PaymentStatusList = [
    {
        value:'paid',
        label: "Đã thanh toán"
    },
    {
        value:'partiallypaid',
        label: "Thanh toán 1 phần"
    },
    {
        value:'unpaid',
        label: "Chưa thanh toán"
    },
]

const PaymentMethodList : any = [
    {
        value:'cash',
        label: "Tiền mặt"
    },
    {
        value:'transfer',
        label: "Chuyển khoản"
    },
]

interface Props {
    history: any,
    location: any,
    match: any,
    user: any,
}

const Detail: React.FC<Props> = (props: Props) => {
    const [loading, setLoading] = useState(false);
    const [id, setId] = useState(props.match.params.id);
    const [onlyView, setOnlyView] = useState(false);
    const [data, setData] = useState<any>({
        day: moment().valueOf(),
        service_quantity: 1
    });
    const [serviceInfo, setServiceInfo] = useState();
    const [modalIsOpen, setIsOpen] = useState(false);
    const [type, setType] = useState(props.match.params.action);
    const [action, setAction] = useState<any>();
    const [payment, setPayment] = useState<any>()
    const [product, setProduct] = useState<any>()

    useEffect(() => {
        setOnlyView(true)
        loadData(id)
        document.title = 'Xem chi tiết đơn hàng'
    }, [id]);
    
    useEffect(() => {
        loadInit()
    }, []);

    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }

    
    const loadInit = async () => {
        
    }

    const loadData = async (id:number) => {
        const url = `${baseUrl}/orders/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            setData({
                ...resData,
            })
            setProduct(resData?.orders_products)
            setPayment(resData?.orders_payments)
        }
    }

    return (
        <React.Fragment>
            <PageTitle
                breadCrumbItems={[
                    { label: `Chi tiết đơn hàng #${id}`, active: true },
                ]}
                title={`Xem chi tiết đơn hàng`}
            />
            <ContentPage 
                {...props}
                data={data}
                setData={(val:any) => setData(val)}
                setServiceInfo={(val:any) => setServiceInfo(val)}
                product={product}
                onlyView={onlyView}
                payment={payment}
                id={id}
                type={type}
                action={action}
                handleActionModal={(data:any) => handleActionModal(data)}
            />
            <ModalPopup
                isOpen={modalIsOpen}
                onRequestClose={() => setIsOpen(false)}
            >
                {action?.type === 'addReceipts' ? 
                    <ReceiptsAdd closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData(id)} designation_id={action?.designation_id} />:
                    <RenderActionModal {...props} closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData(id)} />
                }
            </ModalPopup>
            {loading && <Loader />}
        </React.Fragment>
    );
};

const ContentPage = (props:any) => {
    const {data,type, setData, onlyView, id, product, payment,action, handleActionModal} = props
    const [loading, setLoading] = useState(false)
    const router = useHistory()

    const calTotalPayment = ()=>{
        const total_payment = data?.orders_payment?.reduce((prevPay:any, itemPay:any)=>{
            prevPay = prevPay + Number(itemPay?.payment_total)
            return prevPay
        },0)
        return Math.floor(total_payment || 0)
    }
    
    const getLabelStatus = (status:any) => {
        switch(status) {
            case -1: {
                return <span className="ml-2 label-status bg-danger">Đã hủy</span>
                break;
            }
            case 0: {
                return <span className="ml-2 label-status bg-dark">Mới</span>
                break;
            }
            case 1: {
                return <span className="ml-2 label-status bg-success">Hoàn thành</span>
                break;
            }
            default: {
                return null
                break;
            }
        }
    }

    const getTotalProduct = (product:any)=>{
        const total = product?.reduce((prev:any, item:any)=>{
            prev += (item?.quantity || 0)
            return prev
        },0)
        return <span className="ml-2 total-label">{total}</span>
    }

    return (
        <PageContent className={onlyView ? 'only-view' : ''}>
            <Row>
                <Col md={8} xs={12}>
                    <PageBody>
                        <div className="nutri-title mb-3">Thông tin chung {getLabelStatus(data?.status)}</div>
                        <Row>
                            <Col md={4} xs={12}>
                                <FormGroup className=''>
                                    <Input disabled type="text" value={`Loại đơn: ${data?.order_source ? OrderType?.filter((option: any) => data?.order_type === option.value)[0]?.label : 'POS'}`}/>
                                </FormGroup>
                            </Col>
                            <Col md={4} xs={12}>
                                <FormGroup className=''>
                                    <Input disabled type="text" value={`Người bán: ${data?.created_uid?.name}`} />
                                </FormGroup>
                            </Col>
                            <Col md={4} xs={12}>
                                <FormGroup className=''>
                                    <Input disabled type="text" value={`${data?.branch_id?.name}`}/>
                                </FormGroup>
                            </Col>
                            <Col md={4} xs={12}>
                                <FormGroup className=''>
                                    <Input disabled type="text" value={`Nguồn đơn: ${data?.ordersource_id?.name || '---'}`}/>
                                </FormGroup>
                            </Col>
                            <Col md={4} xs={12}>
                                <FormGroup className=''>
                                    <Input disabled type="text" value={`Thời gian: ${moment(data?.created_time).format('HH:mm DD/MM/YYYY')}`} />
                                </FormGroup>
                            </Col>
                            
                        </Row>
                        <div className="table-responsive" style={{overflow: 'unset'}}>
                            <table className="mb-0 table-custom no-bg table" >
                                <thead>
                                    <tr>
                                        <th style={{ width: 30 }}>Ảnh</th>
                                        <th style={{ width: '30%' }}>Tên sản phẩm</th>
                                        <th style={{ width: '13%' }}>Mã sản phẩm</th>
                                        <th style={{ width: '13%' }}>Giá bán</th>
                                        <th style={{ width: '13%' }}>Số lượng</th>
                                        <th style={{ width: '13%' }}>Giảm giá</th>
                                        <th style={{ width: '35%' }}>Thành tiền</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {product?.map((item:any, index:number)=>{
                                        const dataProduct = item?.variant_id ? {...item?.product_id, ...item?.variant_id} : item?.product_id
                                        return(
                                            <tr key={`prodsuct-${index}`}>
                                                <td>
                                                    <label className="tee-file-preview" htmlFor="avatar" style={{width: 40, height: 40, marginRight: 10}}>
                                                        <img  src={dataProduct?.product_images 
                                                            && dataProduct?.product_images[0] 
                                                            && dataProduct?.product_images[0].url || profilePic} style={{maxWidth: 'unset', maxHeight: 'unset'}}/>
                                                    </label>
                                                </td>
                                                <td>{dataProduct?.name}</td>
                                                <td>{dataProduct?.sku}</td>
                                                <td>
                                                    <ValueText>{PriceUtils.format(item?.price, ' đ')}</ValueText>
                                                </td>
                                                <td>
                                                    <ValueText>{PriceUtils.format(item?.quantity, '')}</ValueText>
                                                </td>
                                                <td>
                                                    <ValueText>{PriceUtils.format(item?.discount, ' đ')}</ValueText>
                                                </td>
                                                <td>
                                                    <ValueText>{PriceUtils.format(Number(item?.total) - Number(item?.discount || 0), ' đ')}</ValueText>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                        
                    </PageBody>
                </Col>
                <Col md={4} xs={12}>
                    <PageBody>
                        <div className="nutri-title mb-3">Giá trị đơn hàng</div>
                        <Row>
                            <Col md={12} xs={12}>
                                <div className='order-total-row mb-2'>
                                    <ValueTextLabel>Tổng tiền hàng {getTotalProduct(product)}</ValueTextLabel>
                                    <ValueTextLabel>{PriceUtils.format(data?.total || 0)}</ValueTextLabel>
                                </div>
                            </Col>
                            <Col md={12} xs={12}>
                                <div className='order-total-row mb-2'>
                                    <ValueTextLabel>Giảm giá</ValueTextLabel>
                                    <ValueTextLabel>{PriceUtils.format(data?.discount || 0)}</ValueTextLabel>
                                </div>
                            </Col>
                            <Col md={12} xs={12}>
                                <div className='order-total-row mb-2'>
                                    <ValueTextLabel>Phải thu khách</ValueTextLabel>
                                    <ValueTextTotal>{PriceUtils.format((data?.total || 0) - (data?.discount || 0))}</ValueTextTotal>
                                </div>
                            </Col>
                            <Col md={12} xs={12}>
                                <div className='order-total-row mb-2'>
                                    <ValueTextLabel>Khách đã trả</ValueTextLabel>
                                    <ValueTextValue>{PriceUtils.format(calTotalPayment())}</ValueTextValue>
                                </div>
                            </Col>
                            <Col md={12} xs={12}>
                                <div className='order-total-row mb-2'>
                                    <ValueTextLabel>Ghi công nợ</ValueTextLabel>
                                    <ValueTextValue>{PriceUtils.format(((data?.total || 0) - (data?.discount || 0)) - calTotalPayment())}</ValueTextValue>
                                </div>
                            </Col>
                        </Row>
                    </PageBody>
                    {/* <div className="card" style={{overflow: 'hidden'}}>
                        <div className="card-body p-0">
                            <div style={{padding:' 1.25rem'}}>
                                <div className="mb-3" style={{display: 'flex', justifyContent:'space-between'}}>
                                    <div className="nutri-title">Thông tin thanh toán</div>
                                    <div style={{display: 'flex', justifyContent:'space-between'}}>
                                        <ValueTextLabel>Tổng tiền: </ValueTextLabel>
                                        <ValueTextTotal className='only-view'>{PriceUtils.format(calTotalPayment())}</ValueTextTotal>
                                    </div>
                                    
                                </div>
                                {
                                    payment?.map((item:any, index:number) => (
                                        <PaymentItem 
                                            detailIndex={index} 
                                            data={item}
                                            type={type}
                                            onlyView={onlyView}
                                            detail={payment}
                                        />
                                    ))
                                }
                            </div>
                            <div style={{display: 'flex', justifyContent:'flex-end', background: '#ECECF2', padding:' 1.25rem'}}>
                                <div style={{display: 'flex', justifyContent:'space-between'}}>
                                    <ValueTextLabel>Còn phải thanh toán: </ValueTextLabel>
                                    <ValueTextTotalPayment className='only-view'>{PriceUtils.format(0)}</ValueTextTotalPayment>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <PageBody>
                        <div className="nutri-title mb-3">Thông tin khách hàng</div>
                        <Row>
                            <Col md={12} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label>Tên khách hàng</Label>
                                    <ValueText>{data?.customer_id?.name}</ValueText>
                                </FormGroup>
                            </Col>
                            <Col md={12} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label>Số điện thoại</Label>
                                    <ValueText>{data?.customer_id?.phone}</ValueText>
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <Link to={`/customer/${data?.customer_id?.id}/view`} target="_blank" rel="noopener noreferrer">
                                    <ViewMore>
                                        <ViewMoreText>Xem chi tiết</ViewMoreText>
                                        <img src={iconViewMore} width={16}/>
                                    </ViewMore>
                                </Link>
                            </Col>
                        </Row>
                    </PageBody>
                </Col>
            </Row>
            <div className="bottom-action">
                <Button color="success" className='success-bland ml-2' onClick={() => router?.goBack()}>Đóng</Button>
                {data?.status === 0 &&
                    <Button color="info" className=' ml-2' onClick={() => props?.handleActionModal({type: 'sell', data: data})}>Bán</Button>
                }
                <Button color="info" className=' ml-2' onClick={() => props?.handleActionModal({type: 'stockReturn', data: data})}>Trả hàng</Button>
                <Button color="success" className='info ml-2' onClick={() => props?.handleActionModal({type: 'print', data: data})}>In đơn hàng</Button>
            </div>
            {loading && <Loader />}
        </PageContent>
    )
}

const PaymentItem = (props:any) => {
    const {detailIndex, detail, onChangeData, data, type, onlyView, handleRemoveData, handleAddData} = props
    const handleChangeData = (event?: any) => {
        const { value, name } = event.target
        if(name == 'name') {
            if(value?.length > 200) return
        }
        onChangeData({
            ...data,
            [name]: value
        })
    }
    
    return (
        <Row key={detailIndex}>
            <Col md={5} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label>Hình thức thanh toán</Label>
                    <Select
                        placeholder={(type=='view' && !data?.payment_method) ? "---" : "Chọn hình thức..."}
                        className="react-select mb-2"
                        classNamePrefix="react-select"
                        isDisabled={onlyView || data?.id}
                        onChange={(val: any) => handleChangeData({ target: { name: 'payment_method', value: val?.value } })}
                        value={PaymentMethodList?.filter(
                            (option: any) => data?.payment_method == option.value
                        )}
                        options={PaymentMethodList}
                    ></Select>
                </FormGroup>
            </Col>
            <Col md={5} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label>Số tiền thanh toán</Label>
                    <NumberFormat 
                        disabled={data?.id}
                        onChange={(e: any) => handleChangeData({ target: { name: 'payment_total', value: TextUtils.onlyNumber(e.target.value) } })}
                        name={'payment_total'} type={'text'} className="form-control" 
                        value={type === 'view' && !data?.payment_total ? '---': data?.payment_total}
                        placeholder={(type=='view' && !data?.payment_total) ? "---" : "Nhập số lượng..."} thousandSeparator={true} 
                    />
                </FormGroup>
            </Col>
            {!onlyView &&
            <Col md={1} xs={12} className="p-0">
                <FormGroup className='nutri-form'>
                    <Label></Label>
                    <div style={{display:'flex'}}>
                    {!data?.id && <Button onClick={handleRemoveData} className='nutri-square bg-none mr-2' color='success'><i className='uil-trash-alt'></i></Button>}
                    {detail?.length == detailIndex+1 && <Button onClick={handleAddData} className='nutri-square' color='success'><i className='uil-plus'></i></Button>}
                    </div>
                </FormGroup>
            </Col>}
        </Row>
    )
}

const RenderActionModal = (props: any) => {
    const [loading, setLoading] = useState(false);
    const { closeModal, action, loadData } = props

    const componentRef = useRef(null);
        const handlePrint = useReactToPrint({
            content: () => componentRef.current,
            copyStyles: true,
        });

    const handleStop = async() => {
        setLoading(true)
        const url = `${baseUrl}/designation/${action?.data?.id}`;
        const params = {
            status: -1,
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Hủy đơn dịch vụ thành công')
            closeModal();
            loadData()
        }
    }

    const handleActive = async() => {
        setLoading(true)
        const url = `${baseUrl}/designation/${action?.data?.id}`;
        const params = {
            status: 1,
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Kích hoạt đơn dịch vụ thành công')
            closeModal();
            loadData()
        }
    }

    const handleDelete = async() => {
        setLoading(true)
        const url = `${baseUrl}/designation/${action?.data?.id}`;
        let response: any = await APIClient.DELETE(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Hủy chỉ định dịch vụ thành công')
            closeModal();
            loadData()
        }
    }

    const handleGo = async() => {
        setLoading(true)
        const url = `${baseUrl}/designation/status/${action?.data?.id}`;
        const params = {
            status: 2,
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Thực hiện đơn dịch vụ thành công')
            closeModal();
            loadData()
        }
    }

    const handleDone = async() => {
        setLoading(true)
        const url = `${baseUrl}/designation/status/${action?.data?.id}`;
        const params = {
            status: 3,
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Hoàn thành đơn dịch vụ thành công')
            closeModal();
            loadData()
        }
    }

    const handleChangeStatus = async() => {
        setLoading(true)
        const url = `${baseUrl}/orders/status/${action?.data?.id}`;
        const params = {
            status: 1,
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Thực hiện bán đơn thuốc thành công')
            closeModal();
            loadData()
        }
    }

    if(!checkRole(props?.user?.roles, ['orderEdit'], props?.user?.role)){
        return (
            <CardBody className='p-0' style={{width:460}}>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-action-title">
                        Thông báo
                    </h5>
                    <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
                </div>
                <div className="modal-body pt-2 pb-2">
                    <Col md={12}>
                        <FormGroup row className="label-only">
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>
                                Bạn không có quyền thực hiện thao tác này
                            </p>
                        </FormGroup>
                    </Col>
                </div>
                <div className="modal-footer">
                    <Button
                        onClick={closeModal}
                        className="ml-2 success-bland" color="success" type="button"
                    > Hủy bỏ</Button>
                </div>
                {loading && <Loader />}
            </CardBody>
    
        )
    }

    if(action?.type == 'print') {
        return (
            <CardBody className='p-0' style={{width:650, overflowX:'hidden'}}>
                <PrintContent 
                id={action?.data?.id}
                componentRef={componentRef}
                />
                <div className="modal-footer">
                    <Button
                        onClick={closeModal}
                        className="ml-2 success-bland" color="success" type="button"
                    > Hủy bỏ</Button>
                    <Button
                        onClick={handlePrint}
                        className="ml-2" color="success" type="button"
                    >In đơn</Button>
                </div>
            </CardBody>
    
        )
    }

    return (
        <CardBody className='p-0' style={{width:400}}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">
                {
                    action?.type === 'stop' ? "Ngừng hoạt động" 
                    : action?.type === 'active' ? "Kích hoạt đơn dịch vụ" 
                    : action?.type === 'go' ? "Thực hiện đơn dịch vụ" 
                    : action?.type === 'done' ? "Hoàn thành đơn dịch vụ" 
                    : action?.type === 'sell' ? "Thực hiện bán đơn thuốc này" 
                    : action?.type === 'stockReturn' ? "Trả hàng đơn thuốc này" 
                    : "Thông báo"
                }
                </h5>
                <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body pt-2 pb-2">
                <Col md={12}>
                    <FormGroup row className="label-only">
                        {action?.type === 'stop' &&
                        <>
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>
                                Bạn có chắc chắn muốn vô hiệu hóa đơn dịch vụ <br/><b>{action?.data?.phone}</b>
                            </p>
                        </>}
                        {action?.type === 'active' &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn muốn kích hoạt đơn dịch vụ này không?</p>
                        }
                        {action?.type === 'delete' &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn hủy chỉ định dịch vụ này không?</p>
                        }
                        {action?.type === 'go' &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn muốn thực hiện đơn dịch vụ này không?</p>
                        }
                        {action?.type === 'done' &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn muốn hoàn thành đơn dịch vụ này không?</p>
                        }
                        {action?.type === 'sell' &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn muốn thực hiện bán đơn dịch vụ này không?</p>
                        }
                        {action?.type === 'stockReturn' &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Tính năng đang phát triển</p>
                        }
                    </FormGroup>
                </Col>
            </div>
            <div className="modal-footer">
                <Button
                    onClick={()=>{
                        action?.type === 'stop' ? handleStop() 
                        : action?.type === 'active' ? handleActive()
                        : action?.type === 'delete' ? handleStop()
                        : action?.type === 'go' ? handleGo()
                        : action?.type === 'done' ? handleDone()
                        : action?.type === 'sell' && handleChangeStatus()
                    }}
                    className="ml-2" color="success" type="button"
                > Xác nhận </Button>
            </div>
            {loading && <Loader />}
        </CardBody>

    )
}

const ValueText = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    &.only-view {
        border-bottom: 1px solid #e2e7f1;
    }
`
const ValueTextLabel = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    color: #1C1D21;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #1C1D21;
`
const ValueTextValue = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    color: #1C1D21;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    margin-left: 20px;
`

const ValueTextTotal = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    color: #EDA119;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    margin-left: 20px;
`

const ViewMore = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`
const ViewMoreText = styled.div`
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    color: #48A800;
    margin-right:10px ;
`

const ValueTextTotalPayment = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #FD4858;
    margin-left: 20px;
`

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

const PageContent = styled.div`
    padding-bottom: 70px;
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`

export default connect(mapState)(Detail)